import { MobXRepository } from "../../../../repository/MobXRepository"
import { IMagazineCategory } from "./IMagazineCategory";

export interface IMagazineCategoryModel {
    magazineCategories: { count: number; rows: IMagazineCategory[] } | null;
    magazineCategory: IMagazineCategory | null;
}

class MagazineCategoryModel implements IMagazineCategoryModel {
    private magazineCategoriesRepository = new MobXRepository<{ count: number; rows: IMagazineCategory[] } | null>(null);
    private magazineCategoryRepository = new MobXRepository<IMagazineCategory | null>(null);

    get magazineCategories() {
        return this.magazineCategoriesRepository.data;
    }

    set magazineCategories(data: { count: number; rows: IMagazineCategory[] } | null) {
        this.magazineCategoriesRepository.save(data);
    }

    get magazineCategory() {
        return this.magazineCategoryRepository.data;
    }

    set magazineCategory(data: IMagazineCategory | null) {
        this.magazineCategoryRepository.save(data);
    }

    clear = () => {
        this.magazineCategories = null;
        this.magazineCategory = null;
    }
}

export const magazineCategoryModel = new MagazineCategoryModel();